import { AppRequestError } from "@app/kit";

export const GENERIC_ERROR = "Не удалось выполнить действие. Проверьте интернет и попробуйте ещё раз.";

// 401 после неудачного refresh — сессии больше нет; 403 — кука чужой роли (клиента
// или админа) на общем домене. Оба случая ведут на экран "откройте из приложения".
export function isDeadSessionError(e: unknown) {
  return AppRequestError.isRequestError(e) && (e.data.statusCode === 401 || e.data.statusCode === 403);
}

// Отказ по правилам смены приходит 400 с кодом и понятным текстом в detail: { notInBaseState: ["Сначала…"] }.
// Его и показываем; всё остальное — общий текст про сбой.
export function errorMessage(e: unknown) {
  if (!AppRequestError.isRequestError(e) || e.data.statusCode !== 400) return GENERIC_ERROR;
  const detail = e.data.response?.data?.detail;
  const text = detail && typeof detail === "object" ? Object.values(detail).flat()[0] : undefined;
  return typeof text === "string" && text ? text : GENERIC_ERROR;
}
